<template>
  <div>
    <ItemPage
      :title="gradeLevel.name ? gradeLevel.name : ''"
      size="md"
    >
      <v-simple-table
        v-if="subjectsFromGradeLevelView"
        fixed-header
      >
        <template v-if="loading">
          <Load :loadingmsg="loadingMsg" />
        </template>
        <v-data-table
          v-else
          :headers="headers"
          :items="subjectsFromGradeLevel"
          hide-default-footer
          :items-per-page="15"
          item-key="id"
          @click:row="editSubject($event)"
        >
          <template #item.name="{ item }">
            <router-link :to="{ name: 'hierarquia.sistema-de-ensino.teachingSystemID.segmento.gradeLevelGroupID.ano.gradeLevelID.materia.subjectID', params: { subjectID: item.id } }">
              {{ item.name }}
            </router-link>
          </template>
        </v-data-table>
      </v-simple-table>
      <template v-else>
        usuário sem permissão
      </template>
    </ItemPage>
    <ItemPage
      title="Volumes"
      size="md"
      :backbtn="false"
      :actions="actions"
    >
      <template
        v-if="volumesView"
      >
        <v-simple-table fixed-header>
          <template v-if="loading">
            <Load :loadingmsg="loadingMsgvolumes" />
          </template>
          <div
            v-else
            class="mr-5 ml-5"
          >
            <v-data-table
              :headers="headersvolumes"
              :items="contentsvolumes"
              :items-per-page="15"
              item-key="id"
            >
              <!-- eslint-disable-next-line -->
              <template v-slot:item.deleteItem="{ item }">
                <v-btn
                  icon
                  @click="confirmDelete(item)"
                >
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </template>
            </v-data-table>
          </div>
        </v-simple-table>
      </template>
      <template v-else>
        usuário sem permissão
      </template>
    </ItemPage>
  </div>
</template>

<script>
import Load from '@/components/Loading.vue'
import utils from '@/api/utils.js'
import ItemPage from '@/components/pages/ItemPage.vue'
import { getTextForDisplay } from '@/enums/volumeTypes'
import AddVolumeDialog from '@/components/settings/AddVolumeDialog.vue'

export default {
  components: {
    Load,
    ItemPage
  },
  data () {
    return {
      volumesView: false,
      volumesCreate: false,
      subjectsFromGradeLevelView: false,
      loading: false,
      loadingSave: false,
      loadingMsg: '',
      loadingMsgvolumes: '',
      gradeLevel: {},
      subjectsFromGradeLevel: [],
      headers: [
        {
          text: 'id',
          align: 'start',
          value: 'id'
        }, {
          text: 'Nome',
          align: 'start',
          value: 'name'
        }
      ],
      contentsvolumes: [],
      headersvolumes: [
        {
          text: 'Nome',
          align: 'start',
          value: 'name'
        },
        {
          text: 'Abreviatura',
          align: 'start',
          value: 'slug'
        },
        {
          text: '',
          align: 'center',
          value: 'deleteItem'
        }
      ]
    }
  },
  computed: {
    teachingSystemID () {
      return this.$route.params.teachingSystemID
    },
    gradeLevelGroupID () {
      return this.$route.params.gradeLevelGroupID
    },
    gradeLevelID () {
      return this.$route.params.gradeLevelID
    },
    subjectID () {
      return this.$route.params.subjectID
    },
    actions () {
      return [
        {
          label: 'Adicionar volume',
          action: this.openAddVolume,
          icon: 'mdi-plus',
          disabled: !this.volumesCreate
        }
      ]
    }
  },
  created () {
    this.fetchAll()
  },
  methods: {
    getTextForDisplay,
    async fetchAll () {
      this.subjectsFromGradeLevelView = utils.checkPermissions('topics.view-any')
      this.volumesView = utils.checkPermissions('volumes.view-any')
      this.volumesCreate = utils.checkPermissions('volumes.create')
      await this.getGradeLevel()
      await this.getSubjectsOfGradeLevel()
      await this.listVolumesByTeachingSystemAndGradeLevel()
    },
    async getGradeLevel () {
      this.loading = true
      this.loadingMsg = 'Carregando lista de cursos...'
      try {
        this.gradeLevel = await this.$api.getGradeLevel(this.gradeLevelID)
      } catch {
        // console.log('Erro ao obter os cursos')
      }
      this.loading = false
    },
    async confirmDelete (item) {
      this.$dialog.confirm('Apagar volume deste curso/ano?')
        .text('Tem certeza que deseja apagar este volume ? não será possível reverter')
        .label('Apagar')
        .onConfirm(async () => {
          await this.$api.deleteVolumeByTeachingSystemAndGradeLevel(this.teachingSystemID, this.gradeLevelID, item.id)
          this.listVolumesByTeachingSystemAndGradeLevel()
        })
        .show()
    },
    async listVolumesByTeachingSystemAndGradeLevel () {
      this.loading = true
      this.loadingMsgvolumes = 'Carregando lista de volumes...'
      try {
        this.contentsvolumes = await this.$api.listVolumesByTeachingSystemAndGradeLevel(this.teachingSystemID, this.gradeLevelID)
      } catch {
        // console.log('Erro ao obter os volumes')
      }
      this.loading = false
    },
    async openAddVolume () {
      this.$dialog.custom(AddVolumeDialog).show()
        .then(async (volume) => {
          if (!volume) {
            return
          }
          const data = {
            volume_id: volume
          }
          await this.$api.addVolumeByTeachingSystemAndGradeLevel(this.teachingSystemID, this.gradeLevelID, data)
          this.listVolumesByTeachingSystemAndGradeLevel()
        })
    },
    async getSubjectsOfGradeLevel () {
      this.loading = true
      this.loadingMsg = 'Carregando lista de matérias...'
      try {
        this.subjectsFromGradeLevel = await this.$api.getSubjectsOfGradeLevel(this.gradeLevelID, this.teachingSystemID)
      } catch {
        // console.log('Erro ao obter matérias')
      }
      this.loading = false
    },
    editSubject (event) {
      this.$router.push({ name: 'hierarquia.sistema-de-ensino.teachingSystemID.segmento.gradeLevelGroupID.ano.gradeLevelID.materia.subjectID', params: { subjectID: event.id } })
    }
  }
}
</script>
